<script>
import { mapGetters } from 'vuex'
import actions from './actions'
import Roles from '@/mixins/Roles'
export default {
    mixins: [actions, Roles],

    computed: mapGetters({
        address: 'address',
    }),

    methods: {
        add(model) {
            this.$store.dispatch('addressAddCompany', model).then(() => {
                this.selected = null
            })
        },
    },
}
</script>
<template lang="pug">
acrm-panel
    acrm-company-select(:disabled="!hasRoleUpdate('address.fields.companies')" v-model="address.companies" @input="add")
    acrm-setting-list-table(
    v-if="address.companies[0]"
    :label="$t('ADDRESSES.ADDED_COMPANIES')"
    :data-array="address.companies"
    :attributes="['name']"
    :translation="['COMPANIES.NAME']"
    :disabled="!hasRoleUpdate('address.fields.companies')"
    del-function="addressDelCompany")
</template>
